import queryString from 'query-string'

import agent from 'agent'
import User from 'models/user'

const urlEncodedHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

export default {
  freeEdition: {
    sendPasswordInvite({
      email,
      firstName,
      lastName,
      requestedDemo,
      sourceUrl
    }) {
      return agent
        .post('/companies/invites/free', {
          admin_email: email,
          first_name: firstName,
          last_name: lastName,
          requested_demo: requestedDemo,
          source_url: sourceUrl
        })
        .then(({ data }) => data)
    },
    getGoogleActivationLink({ accessToken, requested_demo, source_url }) {
      return agent
        .post('/companies/invites/free', {
          provider: 'Google',
          access_token: accessToken,
          requested_demo,
          source_url
        })
        .then(({ data }) => data)
    },
    activatePasswordUser({
      email,
      password,
      code,
      role,
      companyName,
      teamName,
      isRetry
    }) {
      const body = {
        admin_email: email,
        allow_us_storage: true,
        team_name: teamName,
        company_name: companyName,
        code,
        role,
        is_retry: isRetry
      }

      if (password) body.admin_password = password

      return agent.post('/companies', body).then(({ data }) => data)
    },
    activateGoogleUser({ email, code, role, companyName, teamName, isRetry }) {
      return agent
        .post('/companies', {
          admin_email: email,
          allow_us_storage: true,
          team_name: teamName,
          company_name: companyName,
          code,
          role,
          is_retry: isRetry
        })
        .then(({ data }) => data)
    }
  },

  fetchAll() {
    return agent.get('/users').then(({ data }) => toUserList(data))
  },

  activate(identifier) {
    return agent.put(`/users/${identifier}/activate`)
  },

  deactivate(identifier) {
    return agent.delete(`/users/${identifier}`)
  },

  changeRole(identifier, role) {
    return agent.put(
      `/users/${identifier}`,
      queryString.stringify({
        role
      }),
      { headers: urlEncodedHeaders }
    )
  },

  invite(email) {
    return agent.post('/users/invite', queryString.stringify({ email }), {
      headers: urlEncodedHeaders
    })
  },

  deleteInvite(invitedEmail) {
    return agent.delete(`/users/invite/${encodeURIComponent(invitedEmail)}`)
  }
}

function toUserList(data) {
  return Object.keys(data)
    .reduce((arr, value) => arr.concat(data[value]), [])
    .map(u => new User(u))
}
